// Inline message banner. A colored left rule + tinted background; an icon
// reinforces the variant so color isn't the only signal.

import type { ReactNode } from "react";

type BannerVariant = "info" | "warn" | "error";

function BannerIcon({ variant }: { variant: BannerVariant }) {
  if (variant === "info") {
    return (
      <svg
        aria-hidden="true"
        className="banner__icon"
        fill="none"
        height={22}
        viewBox="0 0 24 24"
        width={22}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
        <path
          d="M12 11 V17 M12 7.5 h.01"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="2.4"
        />
      </svg>
    );
  }
  return (
    <svg
      aria-hidden="true"
      className="banner__icon"
      fill="none"
      height={22}
      viewBox="0 0 24 24"
      width={22}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3 L22 21 H2 Z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M12 9 V14 M12 17.5 h.01"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2.4"
      />
    </svg>
  );
}

export function Banner({
  variant = "info",
  children,
}: {
  variant?: BannerVariant;
  children: ReactNode;
}) {
  const className = variant === "info" ? "banner" : `banner banner--${variant}`;
  return (
    <div className={className}>
      <BannerIcon variant={variant} />
      <span>{children}</span>
    </div>
  );
}
